import React from 'react';

export const CustomIcons: Record<string, React.FC<{className?: string}>> = {
  'AllCarts': ({ className = "h-4 w-4" }) => (
    <svg 
      className={className} 
      viewBox="0 0 209 235" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      // Added these to ensure it scales correctly
      preserveAspectRatio="xMidYMid meet"
    >
        <path 
          d="M144.091 127.199C150.622 127.199 156.369 123.187 159.33 117.121L190.506 53.6193C193.728 47.1615 189.548 39.1382 182.93 39.1382H54.0464L45.8605 19.5691H17.3843V39.1382H34.8009L66.1509 113.403L54.3947 137.277C48.0376 150.388 56.3976 166.337 69.6343 166.337H174.134V146.768H69.6343L79.2134 127.199H144.091ZM62.3193 58.7073H168.126L144.091 107.63H82.958L62.3193 58.7073ZM69.6343 176.122C60.0551 176.122 52.3047 184.928 52.3047 195.691C52.3047 206.454 60.0551 215.26 69.6343 215.26C79.2134 215.26 87.0509 206.454 87.0509 195.691C87.0509 184.928 79.2134 176.122 69.6343 176.122ZM156.718 176.122C147.138 176.122 139.388 184.928 139.388 195.691C139.388 206.454 147.138 215.26 156.718 215.26C166.297 215.26 174.134 206.454 174.134 195.691C174.134 184.928 166.297 176.122 156.718 176.122Z" 
          fill="currentColor"
        />
    </svg>
  ),
  'NewRequest': ({ className = "h-4 w-4" }) => (
    <svg 
      className={className} 
      viewBox="0 0 151 151" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <path 
        d="M26 56.7173H125V66.9994H26V56.7173ZM26 77.2814H87.875V87.5635H26V77.2814Z" 
        fill="currentColor"
      />
      <path 
        d="M134.222 0H16.7778C7.55 0 0 7.51254 0 16.6945V133.556C0 142.738 7.55 150.251 16.7778 150.251H134.222C143.45 150.251 151 142.738 151 133.556V16.6945C151 7.51254 143.45 0 134.222 0ZM134.222 133.556H16.7778V16.6945H134.222V133.556Z" 
        fill="currentColor"
      />
    </svg>
  ),
  'AllInventory': ({ className = "h-4 w-4" }) => (
    <svg 
      className={className} 
      viewBox="0 0 234 246" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <path 
        d="M185.25 30.7219H144.495C140.4 18.8428 129.675 10.2407 117 10.2407C104.325 10.2407 93.6 18.8428 89.505 30.7219H48.75C38.025 30.7219 29.25 39.9385 29.25 51.2031V215.053C29.25 226.317 38.025 235.534 48.75 235.534H185.25C195.975 235.534 204.75 226.317 204.75 215.053V51.2031C204.75 39.9385 195.975 30.7219 185.25 30.7219ZM117 30.7219C122.363 30.7219 126.75 35.3302 126.75 40.9625C126.75 46.5949 122.363 51.2031 117 51.2031C111.637 51.2031 107.25 46.5949 107.25 40.9625C107.25 35.3302 111.637 30.7219 117 30.7219ZM185.25 215.053H48.75V51.2031H68.25V81.925H165.75V51.2031H185.25V215.053Z" 
        fill="currentColor"
      />
      <path 
        d="M70.1875 175.251H79.9375V177.801H75.0625V182.9H79.9375V185.45H70.1875V190.55H84.8125V170.151H70.1875V175.251ZM75.0625 129.355H79.9375V108.957H70.1875V114.056H75.0625V129.355ZM70.1875 144.654H78.9625L70.1875 155.363V159.952H84.8125V154.853H76.0375L84.8125 144.144V139.554H70.1875V144.654ZM94.5625 114.056V124.255H162.812V114.056H94.5625ZM94.5625 185.45H162.812V175.251H94.5625V185.45ZM94.5625 154.853H162.812V144.654H94.5625V154.853Z" 
        fill="currentColor"
      />
    </svg>
  ),
  'AllRequest': ({ className = "h-4 w-4" }) => (
    <svg 
      className={className} 
      viewBox="0 0 170 170" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <path 
        d="M58.5116 52.7139H140.744V64.7777H58.5116V52.7139ZM58.5116 76.8416H109.907V88.9055H58.5116V76.8416Z" 
        fill="currentColor"
      />
      <path 
        d="M14.1667 35.2409C10.2709 35.2409 7.08337 38.4125 7.08337 42.289V148.012C7.08337 155.765 13.4584 162.108 21.25 162.108H127.5C131.396 162.108 134.583 158.937 134.583 155.06C134.583 151.184 131.396 148.012 127.5 148.012H28.3334C24.4375 148.012 21.25 144.84 21.25 140.964V42.289C21.25 38.4125 18.0625 35.2409 14.1667 35.2409ZM148.75 7.0481H49.5834C41.7917 7.0481 35.4167 13.3915 35.4167 21.1445V119.819C35.4167 127.572 41.7917 133.916 49.5834 133.916H148.75C156.542 133.916 162.917 127.572 162.917 119.819V21.1445C162.917 13.3915 156.542 7.0481 148.75 7.0481ZM141.667 119.819H56.6667C52.7709 119.819 49.5834 116.647 49.5834 112.771V28.1927C49.5834 24.3162 52.7709 21.1445 56.6667 21.1445H141.667C145.563 21.1445 148.75 24.3162 148.75 28.1927V112.771C148.75 116.647 145.563 119.819 141.667 119.819Z" 
        fill="currentColor"
      />
    </svg>
  ),
  'CartManagementSettings': ({ className = "h-4 w-4" }) => (
    <svg 
      className={className} 
      viewBox="0 0 261 260" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <path 
        d="M86.1643 194.779C74.355 194.779 64.8002 204.518 64.8002 216.421C64.8002 228.324 74.355 238.063 86.1643 238.063C97.9736 238.063 107.636 228.324 107.636 216.421C107.636 204.518 97.9736 194.779 86.1643 194.779ZM193.521 194.779C181.712 194.779 172.157 204.518 172.157 216.421C172.157 228.324 181.712 238.063 193.521 238.063C205.331 238.063 214.993 228.324 214.993 216.421C214.993 204.518 205.331 194.779 193.521 194.779ZM97.9736 140.674H177.955C186.006 140.674 193.092 136.237 196.742 129.528L217.709 93.6438L191.986 103.008L177.955 119.031H102.59L56.8558 21.6421H21.75V43.2842H43.2214L81.87 125.416L67.3768 151.819C59.5397 166.319 69.846 183.958 86.1643 183.958H214.993V162.316H86.1643L97.9736 140.674Z" 
        fill="currentColor"
      />
      <path 
        d="M167.055 40.4228C170.219 40.4228 172.808 43.0215 172.808 46.1975C172.808 49.3736 170.219 51.9722 167.055 51.9722C163.891 51.9722 161.303 49.3736 161.303 46.1975C161.303 43.0215 163.891 40.4228 167.055 40.4228ZM167.055 28.8735C157.506 28.8735 149.798 36.6115 149.798 46.1975C149.798 55.7835 157.506 63.5216 167.055 63.5216C176.604 63.5216 184.313 55.7835 184.313 46.1975C184.313 36.6115 176.604 28.8735 167.055 28.8735ZM203.008 46.1975C203.008 45.5046 203.008 44.7539 202.951 44.0609L214.111 35.5721L199.729 10.5677L186.844 15.9959C185.693 15.2452 184.428 14.4945 183.162 13.8593L181.436 0H152.674L150.948 13.917C149.683 14.5522 148.475 15.3029 147.267 16.0536L134.381 10.5677L120 35.5721L131.16 44.0609C131.102 44.7539 131.102 45.5046 131.102 46.1975C131.102 46.8905 131.102 47.6412 131.16 48.3342L120 56.823L134.381 81.8274L147.267 76.3992C148.417 77.1499 149.683 77.9006 150.948 78.5358L152.674 92.3951H181.436L183.162 78.4781C184.428 77.8428 185.636 77.1499 186.844 76.3414L199.729 81.7697L214.111 56.7652L202.951 48.2764C203.008 47.6412 203.008 46.8905 203.008 46.1975ZM194.84 67.2174L184.888 63.0019C181.667 66.4667 177.41 69.0076 172.635 70.1048L171.255 80.8457H162.856L161.533 70.1048C156.758 69.0076 152.502 66.4667 149.28 63.0019L139.328 67.2174L135.129 59.8836L143.7 53.3582C143.01 51.106 142.665 48.7384 142.665 46.2553C142.665 43.7722 143.01 41.4045 143.7 39.1524L135.129 32.627L139.328 25.2931L149.28 29.5087C152.502 26.0439 156.758 23.503 161.533 22.4058L162.856 11.5494H171.312L172.635 22.2903C177.41 23.3875 181.667 25.9284 184.888 29.3932L194.84 25.1777L199.039 32.5115L190.468 39.0369C191.158 41.2891 191.503 43.6567 191.503 46.1398C191.503 48.6229 191.158 50.9905 190.468 53.2427L199.039 59.7681L194.84 67.2174Z" 
        fill="currentColor"
      />
    </svg>
  ),
  'InventoryRequest': ({ className = "h-4 w-4" }) => (
    <svg 
      className={className} 
      viewBox="0 0 193 222" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M82.3203 10.5405C94.2111 10.5405 104.273 18.6103 108.114 29.7544H108.588V49.4741L128.054 49.7222V77.7896H36.5869V48.9683H18.293V202.68H146.348V76.5806C148.726 76.7402 162.657 77.376 164.641 77.4663V202.68C164.64 213.248 156.409 221.894 146.348 221.894H18.293C8.23187 221.894 0.000139236 213.248 0 202.68V48.9683C1.90735e-05 38.4008 8.2318 29.7547 18.293 29.7544H56.5264C60.368 18.6104 70.4297 10.5406 82.3203 10.5405ZM82.3203 29.7544C77.2899 29.7545 73.1741 34.0773 73.1738 39.3608C73.1738 44.6446 77.2897 48.9681 82.3203 48.9683C87.351 48.9683 91.4668 44.6447 91.4668 39.3608C91.4665 34.0772 87.3509 29.7544 82.3203 29.7544Z" 
        fill="currentColor"
      />
      <path 
        d="M164.663 0V25.5713H192.678V42.6191H164.663V68.1055C164.663 68.1055 146.078 68.1907 145.985 68.1055V42.6191H117.969C117.969 42.6078 118.063 25.6565 117.969 25.5713H145.985V0H164.663Z" 
        fill="currentColor"
      />
      <path 
        d="M30.4375 158.584H41.1875V161.258H35.8125V166.607H41.1875V169.281H30.4375V174.629H46.5625V153.236H30.4375V158.584ZM35.8125 110.449H41.1875V89.0559H30.4375V94.4042H35.8125V110.449ZM30.4375 126.494H40.1125L30.4375 137.726V142.539H46.5625V137.191H36.8875L46.5625 125.959V121.146H30.4375V126.494ZM57.3125 94.4042V105.101H132.562V94.4042H57.3125ZM57.3125 169.281H132.562V158.584H57.3125V169.281ZM57.3125 137.191H132.562V126.494H57.3125V137.191Z" 
        fill="currentColor"
      />
    </svg>
  ),
  'InventoryAvailable': ({ className = "h-4 w-4" }) => (
    <svg 
      className={className} 
      viewBox="0 0 254 226" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <path 
        d="M42.9375 162.452H52.6875V165.002H47.8125V170.102H52.6875V172.652H42.9375V177.751H57.5625V157.353H42.9375V162.452ZM47.8125 116.556H52.6875V96.158H42.9375V101.258H47.8125V116.556ZM42.9375 131.855H51.7125L42.9375 142.564V147.154H57.5625V142.054H48.7875L57.5625 131.345V126.755H42.9375V131.855ZM67.3125 101.258V111.457H135.562V101.258H67.3125ZM67.3125 172.652H135.562V162.452H67.3125V172.652ZM67.3125 142.054H135.562V131.855H67.3125V142.054Z" 
        fill="currentColor"
      />
      <path 
        d="M87.75 0C100.425 0 111.15 8.60239 115.245 20.4814H156C166.725 20.4814 175.5 29.6982 175.5 40.9629V176.94L166.25 185.77L156 176.967V40.9629H136.5V71.6846H39V40.9629H19.5V204.812H129.441L151.157 225.294H19.5C8.77501 225.294 1.13911e-05 216.077 0 204.812V40.9629C0 29.6982 8.775 20.4814 19.5 20.4814H60.2549C64.3499 8.60239 75.075 0 87.75 0ZM87.75 20.4814C82.3875 20.4814 78 25.0903 78 30.7227C78.0002 36.3548 82.3876 40.9629 87.75 40.9629C93.1124 40.9629 97.4998 36.3548 97.5 30.7227C97.5 25.0903 93.1125 20.4814 87.75 20.4814Z" 
        fill="currentColor"
      />
      <path 
        d="M164.75 192.95L143.75 174.272L126.75 192.95L164.75 225.491L253.631 136.393L236.75 120.76L164.75 192.95Z" 
        fill="currentColor"
      />
    </svg>
  ),
  'MyRequest': ({ className = "h-4 w-4" }) => (
    <svg 
      className={className} 
      viewBox="0 0 151 162" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <path 
        d="M22 40H129V50.3333H22V40ZM22 60.6667H88.875V71H22V60.6667Z" 
        fill="currentColor"
      />
      <path 
        d="M49.5 116C60.8218 116 70 106.822 70 95.5C70 84.1782 60.8218 75 49.5 75C38.1782 75 29 84.1782 29 95.5C29 106.822 38.1782 116 49.5 116Z" 
        fill="currentColor"
      />
      <path 
        d="M137.273 0H13.7273C6.17727 0 0 7.1 0 15.7778V78.8889H13.7273V15.7778H137.273V131.403V142C144.823 142 151 134.9 151 126.222V15.7778C151 7.1 144.823 0 137.273 0Z" 
        fill="currentColor"
      />
      <path 
        d="M83.6419 129.36C73.8769 124.2 61.2056 120 46.5 120C31.7944 120 19.1231 124.2 9.35812 129.36C3.54562 132.42 0 138.6 0 145.32V162H93V156V153.66V145.32C93 138.6 89.4544 132.42 83.6419 129.36Z" 
        fill="currentColor"
      />
      <path 
        d="M104 142C104 142 136.101 142.133 138 141.5C139.5 141 138 129 138 129H105.522L104 142Z" 
        fill="currentColor" 
        stroke="currentColor"
      />
    </svg>
  ),
  'RequestForm': ({ className = "h-4 w-4" }) => (
    <svg 
      className={className} 
      viewBox="0 0 151 151" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <path 
        d="M134.222 0H16.7778C7.55 0 0 7.51254 0 16.6945V133.556C0 142.738 7.55 150.251 16.7778 150.251H134.222C143.45 150.251 151 142.738 151 133.556V16.6945C151 7.51254 143.45 0 134.222 0ZM134.222 133.556H16.7778V16.6945H134.222V133.556Z" 
        fill="currentColor"
      />
    </svg>
  ),
  'PendingPaymentsBank': ({ className = "h-4 w-4" }) => (
    <svg 
      className={className} 
      viewBox="0 0 208 190" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      {/* Clock Detail */}
      <path 
        d="M58.3283 78.4312C28.2632 77.3651 2.99731 100.901 1.93125 130.966C0.86519 161.031 24.4006 186.297 54.4657 187.363C84.5308 188.429 109.797 164.893 110.863 134.828C111.929 104.763 88.3934 79.4972 58.3283 78.4312ZM80.3628 164.431L42.3628 144.931L41.3628 107.431L51.3628 107.431L52.3628 139.431L84.3628 155.431L80.3628 164.431Z" 
        fill="currentColor"
      />
      {/* Bank Building Detail */}
      <path 
        d="M90.4737 72.45H74.2632V128.8H90.4737V72.45ZM139.105 72.45H122.895V128.8H139.105V72.45ZM208 136.4H99.5V152.5H208V136.4ZM187.737 72.45H171.526V128.8H187.737V72.45ZM131 0L54 40.25V56.35H208V40.25L131 0Z" 
        fill="currentColor"
      />
    </svg>
  ),
  'PendingRequestClock': ({ className = "h-4 w-4" }) => (
    <svg 
      className={className} 
      viewBox="0 0 171 207" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      {/* Document Lines */}
      <path 
        d="M41.3628 52H148.363V62.3333H41.3628V52ZM41.3628 72.6667H108.238V83H41.3628V72.6667Z" 
        fill="currentColor"
      />
      {/* Document Frame */}
      <path 
        d="M156.636 0H33.0901C25.5401 0 19.3628 7.1 19.3628 15.7778V78.8889H33.0901V15.7778H156.636V131.403V142C164.186 142 170.363 134.9 170.363 126.222V15.7778C170.363 7.1 164.186 0 156.636 0Z" 
        fill="currentColor"
      />
      {/* Tab Detail */}
      <path 
        d="M123.363 142C123.363 142 155.464 142.133 157.363 141.5C158.863 141 157.363 129 157.363 129H124.885L123.363 142Z" 
        fill="currentColor" 
        stroke="currentColor"
      />
      {/* Clock Overlay */}
      <path 
        d="M58.3283 96.0001C28.2632 94.9341 2.99734 118.47 1.93128 148.535C0.865219 178.6 24.4007 203.866 54.4658 204.932C84.5309 205.998 109.797 182.462 110.863 152.397C111.929 122.332 88.3934 97.0662 58.3283 96.0001ZM80.3628 182L42.3628 162.5L41.3628 125L51.3628 125L52.3628 157L84.3628 173L80.3628 182Z" 
        fill="currentColor"
      />
    </svg>
  ),
  'PendingItems': ({ className = "h-4 w-4" }) => (
    <svg 
      className={className} 
      viewBox="0 0 683 652" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      {/* Outer Rounded Container Border */}
      <rect 
        x="22.5" 
        y="22.5" 
        width="638" 
        height="607" 
        rx="103.5" 
        stroke="currentColor" 
        strokeWidth="45"
      />
      {/* Exclamation Stem */}
      <path 
        d="M409.331 108H275L297.602 403.868H383.903L409.331 108Z" 
        fill="currentColor"
      />
      {/* Exclamation Dot */}
      <path 
        d="M383.825 503.765C383.825 526.539 364.983 545 341.74 545C318.498 545 299.656 526.539 299.656 503.765C299.656 480.992 318.498 462.531 341.74 462.531C364.983 462.531 383.825 480.992 383.825 503.765Z" 
        fill="currentColor"
      />
    </svg>
  ),
  
};

export const CUSTOM_ICON_NAMES = Object.keys(CustomIcons);